import Api from '@/Api'

export default class ReportingApi extends Api {
  /**
   * Fetches the available report types
   * @param {Object}   [options={}] - configuration for the API request
   */
  getReportTypes = (options = {}) => {
    return this.post('/api/v1/private/reports/types', options.params)
  };
}
